// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".panel-wrapper[data-v-52c1d1c4]{background:#fff;padding:.938vw}.panel-content[data-v-52c1d1c4]{height:8.542vw;display:flex}.panel-content .left[data-v-52c1d1c4]{height:100%;display:flex;flex:1;justify-content:space-around;align-items:center;padding-top:1.563vw}", ""]);
// Exports
module.exports = exports;
